var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrevButtonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a8f2c647-794d-4393-9f6f-a2818aed3d8d",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.93 10.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-533f1891-e152-4b14-9fdd-77c8e7ae6331{fill:#f7f2ee;}.uuid-0ec90cf5-033e-4b78-b356-9ee5abcc7363{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:.7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d461e058-594a-4c99-9b79-60b74dd938a3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-533f1891-e152-4b14-9fdd-77c8e7ae6331",
    cx: 5.46,
    cy: 5.46,
    r: 5.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.38,
    y: 5.1,
    width: 4.78,
    height: 0.77,
    transform: "translate(11.53 10.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-0ec90cf5-033e-4b78-b356-9ee5abcc7363",
    x1: 3.98,
    y1: 6.9,
    x2: 2.77,
    y2: 5.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-0ec90cf5-033e-4b78-b356-9ee5abcc7363",
    x1: 2.77,
    y1: 5.7,
    x2: 3.98,
    y2: 4.06
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevButtonIcon);
export default __webpack_public_path__ + "static/media/prev_button_icon.a39acbaf96b750c53e6fe2a7a0def6b7.svg";
export { ForwardRef as ReactComponent };